import axios from "axios";
import { useEffect, useState } from "react";

export default function ViewQuestion(props){

    const id =props.id;
    const [data, setData]=useState([]);

    function getData(id){
        axios.get(`${process.env.REACT_APP_BASE_URL}api/question/secured/getQuestion/`+id)
        .then(result=>setData(result.data))
        .catch(err=>console.log(err));
    }
    useEffect(()=>getData(id),[id]);

    return(<div className="container view-container">
          <button className="btn btn-danger" style={{float:"right"}} onClick={()=>props.event()}>X</button>
       <h2 className="text-center">View Question</h2>
       <hr />
       <div className="row">
           <table className="table">
            <tbody>
                <tr>
                    <td>Question</td>
                    <td>{data.question || "Null"}</td>
                </tr>
                <tr>
                    <td>Answer</td>
                    <td>{data.answer || "Null"}</td>
                </tr>
                <tr>
                    <td>option1</td>
                    <td>{data.option1 || "Null"}</td>
                </tr>
                <tr>
                    <td>option2</td>
                    <td>{data.option2 || "Null"}</td>
                </tr>
                <tr>
                    <td>option3</td>
                    <td>{data.option3 || "Null"}</td>
                </tr>
                <tr>
                    <td>option4</td>
                    <td>{data.option4 || "Null"}</td>
                </tr>
            </tbody>
           </table>
       </div>
    </div>);
}